export default "__VITE_ASSET__DzvRbdS2__"